/**
 * TIP Shell — name scrubber (defense in depth).
 *
 * Broker results (getMyToken / writeScore / getScores, §7) are name-free BY
 * CONTRACT — scores key on the surrogate student id, tokens are opaque. Before ANY
 * broker payload crosses the Bridge into the frame we still strip name-like keys, so
 * a server bug can never turn the broker channel into a name-egress path. This runs
 * in BOTH tiers (standard names travel via tip:init, never via the broker).
 */

const NAME_KEYS: ReadonlySet<string> = new Set([
  'given',
  'given_name',
  'name',
  'first_name',
  'last_name',
  'full_name',
  'fullname',
  'display_name',
  'email',
  'photo',
  'photo_url',
  'voice',
]);

/** A key is name-bearing if it is a known name key or ends in _name/_given/_email/… */
function isNameKey(key: string): boolean {
  const k = key.toLowerCase();
  return NAME_KEYS.has(k) || /(^|_)(name|given|email|photo|voice)$/.test(k);
}

/** Deep-copy `value`, dropping any name-bearing keys. Arrays/scalars pass through. */
export function scrubNames(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(scrubNames);
  if (value && typeof value === 'object') {
    const out: Record<string, unknown> = {};
    for (const [k, v] of Object.entries(value as Record<string, unknown>)) {
      if (isNameKey(k)) continue;
      out[k] = scrubNames(v);
    }
    return out;
  }
  return value;
}
